var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ transform: 'translate(-50%, -50%) scale('+_vm.pageScale+' )'}),attrs:{"id":"app"}},[_c('router-link',{staticClass:"homebutton",attrs:{"to":"/start"}},[_vm._v("\n    Zum Startbildschirm\n  ")]),_c('main',[_c('router-view')],1),_c('footer',[_c('ActionList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }